import moment from "moment-timezone"

export function homologateStatusWithColor(status) {
  switch (status) {
    case 'PROSPECTO':
      return { color: '#fce09e', status: 'Prospecto' };
      break;
    case 'INACTIVO':
      return { color: '#fad0bf', status: 'Inactivo' };
      break;
    case 'ACTIVE':
      return { color: '#9bf4d5', status: 'Activo' };
      break;
    case 'EXPIRED':
      return { color: '#f2f2f2', status: 'Expirado' };
      break;
    case 'DESARROLLADOR':
      return { color: '#e2cffc', status: 'Desarrollador' };
      break;
    case 'APPROVED':
      return { color: '#fce09e', status: 'Aprobado' };
      break;
    case 'TEMPORALLY_LEAVE':
      return { color: '#e2cffc', status: 'Baja Temporal' };
    default:
      return { color: '#88f4d8', status: status };
  }
}

export function isActivePaymentNationalH(affiliation) {
  if (affiliation) {
    if (affiliation.national && affiliation.national._id) {
      if (affiliation.national.details) {
        let nationalAffiliationDetails = affiliation.national.details[0];

        return ableToRenewH(nationalAffiliationDetails);
      }
      return true;
    }
  }
  return false;
}

export function isActivePaymentLocalH(affiliation) {
  if (affiliation) {
    if (affiliation.local && affiliation.local._id) {
      if (affiliation.local.details) {
        let localAffiliationDetails = affiliation.local.details[0];
        return ableToRenewH(localAffiliationDetails);
      }
      return true;
    }
  }
  return false;
}

/**
 * validate if user is able to renew based on affiliation information
 * @param {*} affiliationInformation
 * @returns
 */
export function ableToRenewH(affiliationInformation) {
  const currentDate = moment();
  const { status = null, affiliateInformation = null, affiliationType = null } = affiliationInformation;

  if (!affiliateInformation || status != 'ACTIVE') return false;


  const prepaidConfig = affiliationType?.prepaidConfig
  const dateToExpire = affiliateInformation?.inactiveDate || affiliateInformation?.expirationDate

  const memberExpirationDate = moment(dateToExpire);

  if (!!prepaidConfig && prepaidConfig?.active) {
    const { periodQuantity = 0, period = 'days' } = prepaidConfig;
    memberExpirationDate.add(-periodQuantity, String(period).toLowerCase())
  }

  return currentDate.isSameOrAfter(memberExpirationDate);
}


/**
 * Retrieve the primary affiliation detail object for a user.
 *
 * @export
 * @param {Object} params
 * @param {Object} params.user
 * @param {string} [params.affiliationLevel='national'] - 'national' or 'local'
 * @returns {Object}
 */
export function retrieveMemberAffiliationDetails({
  user = null,
  affiliationLevel = 'national',
}) {
  if (!user) return {};

  const membershipDetails = user?.affiliation[affiliationLevel]?.details || [];

  return membershipDetails.length > 0 ? membershipDetails[0] : {};
}
